import {TextInput as MantineTextInput, TextInputProps} from '@mantine/core';
import React, {FC, useContext} from 'react';
import {AdapterProps, FieldAdapter} from '../field-factory';
import {ReadOnlyContext} from '../readonly-context';

export type $TextInputAdapterProps = AdapterProps<TextInputProps>;

export const $TextInputAdapter: FC<FieldAdapter<$TextInputAdapterProps>> = ({
  inputProps: {disabled, onChange, ...inputProps},
  control,
}) => {
  const {readOnly} = useContext(ReadOnlyContext);
  const {
    field: {onChange: fieldOnChange, value = '', ...fieldProps},
    fieldState: {invalid},
  } = control;

  const _onChange: TextInputProps['onChange'] = (e) => {
    fieldOnChange(e);
    onChange?.(e);
  };

  return (
    <MantineTextInput
      error={invalid}
      disabled={disabled || readOnly}
      onChange={_onChange}
      autoComplete='off'
      value={value}
      {...fieldProps}
      {...inputProps}
    />
  );
};
